module.exports = __webpack_public_path__ + "static/media/ios-help-circle-outline.6524a35b.svg";